<aside
  class="fixed inset-y-0 left-0 z-30 flex flex-col bg-primary-800 transition-all duration-200"
  [class.w-64]="!uiStore.sidebarCollapsed()"
  [class.w-16]="uiStore.sidebarCollapsed()"
  [class.-translate-x-full]="!uiStore.sidebarOpen()">

  <!-- Logo & collapse toggle -->
  <div class="flex h-16 items-center border-b border-primary-700/50 px-4"
    [class.justify-center]="uiStore.sidebarCollapsed()"
    [class.gap-2]="!uiStore.sidebarCollapsed()">
    <img src="bestie-circle-outline-colored.svg" alt="Bestie" class="h-8 w-8 shrink-0" />
    @if (!uiStore.sidebarCollapsed()) {
      <span @fadeIn class="text-xl font-bold text-accent-500">Bestie Admin</span>
    }
    <button
      (click)="uiStore.toggleSidebarCollapse()"
      class="ml-auto shrink-0 flex items-center rounded-lg p-1 text-white/50 hover:bg-primary-600/30 hover:text-white transition-colors">
      <app-icon [name]="uiStore.sidebarCollapsed() ? 'chevron-right' : 'chevron-left'" size="md" />
    </button>
  </div>

  <!-- Navigation -->
  <nav class="flex-1 overflow-y-auto py-4">
    @for (group of navGroups(); track group.label; let first = $first) {
      @if (!first) {
        <div class="my-3 border-t border-primary-600/50"></div>
      }
      @if (!uiStore.sidebarCollapsed()) {
        <div @fadeIn class="px-4 py-1 text-xs font-semibold uppercase tracking-wider text-white/40">{{ group.label }}</div>
      }
      @for (item of group.items; track item.route) {
        @if (item.locked) {
          <span
            aria-disabled="true"
            class="flex cursor-not-allowed items-center py-2.5 text-sm text-white/30"
            [class.px-4]="!uiStore.sidebarCollapsed()"
            [class.justify-center]="uiStore.sidebarCollapsed()"
            [class.gap-3]="!uiStore.sidebarCollapsed()"
            title="Finish setting up your first facility to use this.">
            <app-icon [name]="item.icon" size="md" />
            @if (!uiStore.sidebarCollapsed()) {
              <span @fadeIn>{{ item.label }}</span>
            }
          </span>
        } @else {
          <a
            [routerLink]="item.route"
            routerLinkActive="bg-primary-600/50 border-l-3 border-accent-500"
            [routerLinkActiveOptions]="{ exact: item.route === '/home' }"
            class="flex items-center py-2.5 text-sm text-white/90 hover:bg-primary-600/30 hover:text-white transition-colors"
            [class.px-4]="!uiStore.sidebarCollapsed()"
            [class.justify-center]="uiStore.sidebarCollapsed()"
            [class.gap-3]="!uiStore.sidebarCollapsed()"
            [title]="uiStore.sidebarCollapsed() ? item.label : ''">
            <app-icon [name]="item.icon" size="md" />
            @if (!uiStore.sidebarCollapsed()) {
              <span @fadeIn>{{ item.label }}</span>
              @if (item.hasWarning) {
                <span class="ml-auto text-warning-400" title="A Gingr feeding or medication schedule is not mapped.">
                  <app-icon name="exclamation-triangle" size="sm" />
                </span>
              }
            }
          </a>
        }
      }
    }
  </nav>
</aside>
